{
  "generic.edit": "Edit",
  "generic.delete": "Delete",
  "generic.update": "Update",
  "generic.create": "Create",
  "generic.cancel": "Cancel",
  "generic.confirm": "Confirm",
  "generic.print": "Print",
  "generic.close": "Close",
  "generic.save": "Save",
  "generic.yes": "Yes",
  "generic.no": "No",
  "generic.save-validation": "Please fix errors in the form.",

  "input.select-certificate": "Select a certificate",
  "input.select-checklist": "Select a checklist",
  "input.select-function": "Select a function",
  "input.select-organisation": "Select an organisation",
  "input.select-project": "Select a project",
  "input.select-safety-instruction": "Select a safety instruction",
  "input.select-toolbox": "Select a toolbox",

  "context-menu.tab-actions.close": "Close tab",
  "context-menu.tab-actions.close-all": "Close all tabs",
  "context-menu.tab-actions.close-others": "Close other tabs",
  "context-menu.tab-actions.split-horizontal": "Split horizontally",
  "context-menu.tab-actions.split-vertical": "Split vertically",
  "context-menu.tab-open.open": "Open",
  "context-menu.tab-open.open-right": "Open right",
  "context-menu.tab-open.open-bottom": "Open bottom",
  "menu.organisations": "Organisations",
  "menu.people": "Persons",
  "menu.people.list": "List",
  "menu.people.review": "Review",
  "menu.projects": "Projects",
  "menu.certificates": "Certificates",
  "menu.safety": "Safety reports",
  "menu.content": "Content",
  "menu.instructions": "Instructions",
  "menu.checklists": "Checklists",
  "menu.toolboxes": "Toolboxes",
  "menu.thesaurus": "Thesaurus",
  "menu.app-users": "App users",
  "menu.email-log": "Email log",
  "menu.section.platform": "Platform",
  "menu.account": "Account",

  "recompletion.title": "Must everyone complete this again?",
  "recompletion.message": "You are changing content people have already completed. Is the change big enough that they have to go through it again? Choose \u2018Complete again\u2019 to clear every completion, or \u2018Keep completions\u2019 to leave them as they are.",
  "recompletion.keep": "Keep completions",
  "recompletion.reset": "Complete again",

  "app-users.title": "App users",
  "app-users.unnamed": "Unnamed account",
  "app-users.table.avatar": "Photo",
  "app-users.table.email": "Email address",
  "app-users.table.first-name": "First name",
  "app-users.table.last-name": "Last name",
  "app-users.table.nickname": "Nickname",
  "app-users.table.date-of-birth": "Date of birth",
  "app-users.table.organisations": "Organisations",
  "app-users.table.last-login": "Last login",
  "app-users.table.never-logged-in": "Never logged in",
  "app-user-detail.load-error": "Failed to load the app user",
  "app-user-detail.nickname": "Nickname",
  "app-user-detail.identity": "Identity",
  "app-user-detail.email": "Email address",
  "app-user-detail.date-of-birth": "Date of birth",
  "app-user-detail.last-login": "Last login",
  "app-user-detail.person-records": "Person records",
  "app-user-detail.no-person-records": "No organisation holds a person record for this account.",
  "app-user-detail.wallet": "Wallet",
  "app-user-detail.wallet.empty": "This account holds nothing in its wallet yet.",
  "app-user-detail.wallet.employments": "Employments",
  "app-user-detail.wallet.certificates": "Certificates",
  "app-user-detail.wallet.content": "Completed content",
  "app-user-detail.wallet.company": "Company",
  "app-user-detail.certificate-number": "Certificate number",
  "app-user-detail.signed": "Signed",
  "app-user-detail.not-signed": "Not signed",
  "app-user-detail.issued-by": "Issued by",
  "app-user-detail.portal-access": "Portal access",
  "app-user-detail.platform-admin": "Platform admin",
  "app-user-detail.platform-admin.hint": "Grants full access to the admin portal, across every organisation.",
  "app-user-detail.platform-admin.yes": "Platform admin",
  "app-user-detail.platform-admin.no": "Not an admin",
  "app-user-detail.platform-admin.grant": "Make admin",
  "app-user-detail.platform-admin.revoke": "Revoke admin",
  "app-user-detail.platform-admin.grant-confirm": "This account will get full access to the admin portal, across every organisation. The access applies from their next sign-in.",
  "app-user-detail.platform-admin.revoke-confirm": "This account will lose access to the admin portal.",
  "app-user-detail.platform-admin.granted": "The account is now a platform admin",
  "app-user-detail.platform-admin.revoked": "The admin role has been revoked",
  "app-user-detail.platform-admin.cannot-revoke-own": "You cannot revoke your own admin role. Ask another platform admin to do it.",
  "app-user-detail.platform-admin.error": "Could not change the admin role",
  "attestation.status.Pending": "Pending",
  "attestation.status.Active": "Valid",
  "attestation.status.Expired": "Expired",
  "attestation.status.Withdrawn": "Withdrawn",

  "auth.login.title": "Login to the i-LOP platform portal",
  "auth.login.description": "Use your i-LOP account to log in to the platform portal.",
  "auth.login.form.email": "Email address",
  "auth.login.form.email.placeholder": "Enter your email address",
  "auth.login.form.password": "Password",
  "auth.login.form.password.placeholder": "Enter your password",
  "auth.login.form.submit": "Login",
  "auth.login.form.yivi": "Login with Yivi",
  "auth.login.form.forgot": "Forgot password?",
  "auth.forgot-password.title": "Forgot password",
  "auth.forgot-password.description": "No problem! Just enter your email address below and click 'Send reset link'. If your email address is known to us, you will receive a link to reset your password.",
  "auth.forgot-password.form.email": "Email address",
  "auth.forgot-password.form.email.placeholder": "Enter your email address",
  "auth.forgot-password.form.submit": "Send reset link",
  "auth.forgot-password.form.back-to-login": "Back to login",
  "auth.forgot-password.form.success.sent-to": "We sent a confirmation email to",
  "auth.forgot-password.form.success.check-email": "Check your email and click on the confirmation link to continue.",
  "auth.reset-password.title": "Reset password",
  "auth.reset-password.description": "You have chosen to reset your password. Use the form below to enter your new password. Once you’ve updated it, you will need to log in again.",
  "auth.reset-password.form.password": "New password",
  "auth.reset-password.form.password.placeholder": "Enter your new password",
  "auth.reset-password.form.password-confirm": "Confirm new password",
  "auth.reset-password.form.password-confirm.placeholder": "Enter your new password again",
  "auth.reset-password.form.submit": "Change password",
  "auth.reset-password.form.success": "Your password has been changed successfully. You can now log in with your new password.",
  "auth.reset-password.form.back-to-login": "Back to login",
  "auth.reset-password.form.password-mismatch": "The passwords do not match. Please check your input and try again.",
  "table.per-page": "Items per page:",
  "table.empty.title": "No data found",
  "table.empty.sub-title": "There have been no results for your current selection. Try adjusting your filters or create a new item.",
  "table.toast.error": "Something went wrong while fetching the data",
  "organisations.table.logo": "Logo",
  "organisations.table.organisation-name": "Organisation Name",
  "organisations.table.business-registry-number": "Chamber of Commerce number",
  "organisations.table.city": "City",
  "organisations.table.street-name": "Street",
  "organisations.table.website": "Website",
  "organisations.new": "New Organisation",
  "organisations.title": "List of Organisations",
  "organisation-edit.edit-title": "Edit Organisation",
  "organisation-edit.new-title": "New Organisation",
  "organisation-edit.delete-button": "Delete Organisation",
  "organisation-edit.delete-title": "Delete Organisation",
  "organisation-edit.delete-confirm": "Delete",
  "organisation-edit.delete-message": "Are you sure you want to delete this organisation?",
  "organisation-edit.delete-success": "Organisation deleted successfully.",
  "organisation-edit.delete-error": "An error occurred while deleting the organisation.",
  "organisation-edit.roles-load-error": "Could not determine your permissions for this organisation, so it is shown read-only.",
  "organisation-edit.manage-role-assignments": "Manage Role Assignments",
  "organisation-edit.manage-safety-requirements": "Manage Safety Requirements",
  "organisation-form.general-data": "General data",
  "organisation-form.visitor-address": "Visitor address",
  "organisation-form.postal-address": "Postal address",
  "organisation-form.active": "Active",
  "organisation-form.logo": "Logo",
  "organisation-form.click-to-upload-logo": "Click to upload logo",
  "organisation-form.remove-logo": "Remove logo",
  "organisation-form.coc-number": "Chamber of Commerce number",
  "organisation-form.organisation-name": "Organisation name",
  "organisation-form.description": "Description",
  "organisation-form.description.required": "Description is required",
  "organisation-form.description.not-translated": "Please translate description to all languages",
  "organisation-form.parent-organisation": "Parent organisation",
  "organisation-form.email-address": "Email address",
  "organisation-form.website": "Website",
  "organisation-form.phone-number": "Phone number",
  "organisation-form.oin-number": "OIN number",
  "organisation-form.city": "City",
  "organisation-form.street": "Street",
  "organisation-form.house-number": "House Number",
  "organisation-form.zip-code": "Postal code",
  "organisation-form.save-success": "Organisation saved successfully.",
  "organisation-form.save-error": "An error occurred while saving the organisation.",
  "organisation-form.save-validation": "Please fix errors in the form.",
  "organisation-form.website.invalid": "Please enter a valid URL (starting with http:// or https://)",
  "PlatformAdmin": "Platform administrator",
  "app-role.View": "View",
  "app-role.Admin": "Admin",
  "app-role.SafetyCoordinator": "Safety Coordinator",
  "app-role.Foreman": "Foreman",
  "toast.error": "Error",
  "toast.success": "Success",
  "toast.warning": "Warning",
  "toast.info": "Information",
  "password-complexity.requirements": "Passwords must contain at least:",
  "password-complexity.min-length": "At least {{minLength}} characters",
  "password-complexity.uppercase": "At least one uppercase letter",
  "password-complexity.lowercase": "At least one lowercase letter",
  "password-complexity.digit": "At least one number",
  "password-complexity.special-char": "At least one special character",
  "errors.authentication.invalid": "Your email address or password is incorrect",
  "errors.authentication.try_later": "It is currently not possible to log in. Please try again later.",
  "errors.authentication.generic": "Something went wrong while logging in. Please try again.",
  "errors.authentication.yivi_failed": "Login with Yivi failed. Please try again.",
  "errors.reset.generic": "Potentially this token has already been used or has expired. Please try again.",
  "errors.invitation.generic": "The invitation could not be sent. Please try again.",
  "errors.invitation.already-accepted": "This employment has already been accepted; there is nothing to invite.",
  "errors.invitation.not-invitable": "This employment is rejected or has ended; it cannot be invited.",
  "errors.invitation.email-failed": "The invitation email could not be sent. Try again to resend the same link.",
  "errors.withdrawal.generic": "The employment could not be withdrawn. Please try again.",
  "errors.withdrawal.end-date-not-removed": "The end date could not be removed. Please try again.",
  "errors.employment.approval-remark-required": "You changed the employment request; add a remark for the worker before approving.",
  "errors.revocation.generic": "The offer could not be revoked. Please try again.",
  "errors.withdrawal.not-withdrawable": "Only an accepted employment can be withdrawn.",
  "errors.withdrawal.already-withdrawn": "This employment has already been withdrawn. A withdrawal is final and cannot be changed.",
  "errors.withdrawal.date-invalid": "The effective end date cannot be before the start date.",
  "errors.withdrawal.not-revocable": "This offer has already been accepted; withdraw the employment instead.",
  "auth.invalid-role.title": "No access",
  "auth.invalid-role.description": "You do not have access to this application with this account. Please contact your system administrator for more information.",
  "auth.invalid-role.back-to-login": "Back to login",
  "context-menu.account.logout": "Logout",
  "errors.generic": "An error occurred. Please try again later.",
  "errors.person.email-duplicate": "A person with this email address already exists.",
  "organisation-edit.admins": "Admins",
  "invite-or-add-person-modal.title": "Invite or add person",
  "invite-or-add-person-modal.description": "Use this modal to invite a new person or add an existing person to the organisation. First, enter the email address of the person you want to add. If they are not registered yet, you need to fill in their details.",
  "invite-or-add-person-modal.step2.description": "This person does not exist yet. Please fill in the details below.",
  "invite-or-add-person-modal.form.email": "Email address",
  "invite-or-add-person-modal.form.email.placeholder": "Enter the email address of the person you want to add",
  "invite-or-add-person-modal.next": "Next",
  "invite-or-add-person-modal.cancel": "Cancel",
  "invite-or-add-person-modal.back": "Back",
  "invite-or-add-person-modal.create": "Add",
  "add-person-by-email-modal.title": "Add person",
  "add-person-by-email-modal.description": "Enter an email address to check whether this person already exists.",
  "add-person-by-email-modal.form.email": "Email address",
  "add-person-by-email-modal.continue": "Continue",
  "add-person-by-email-modal.multiple-matches": "Multiple persons were found with this email address. Select the person from the correct organisation.",
  "add-person-by-email-modal.back": "Back",
  "edit-person-role-modal.title": "Edit person's role",
  "edit-person-role-modal.description": "Use this modal to edit the person's role within the organisation.",
  "edit-person-role-modal.form.role": "Role",
  "edit-person-role-modal.form.role.placeholder": "Select role",
  "edit-person-role-modal.save": "Save",
  "edit-person-role-modal.cancel": "Cancel",
  "context-menu.person-reference.remove": "Remove person",
  "context-menu.person-reference.change-role": "Change role",
  "projects.table.logo": "Logo",
  "projects.table.project-name": "Project Name",
  "projects.table.project-code": "Project Code",
  "projects.table.client": "Client",
  "projects.table.contractor": "Contractor",
  "projects.table.owner": "Owner",
  "projects.table.city": "City",
  "projects.table.street-name": "Street",
  "projects.new": "New Project",
  "projects.title": "List of Projects",
  "project-edit.title-edit": "Edit Project",
  "project-edit.title-new": "New Project",
  "project-edit.delete": "Delete Project",
  "project-edit.close": "Close",
  "project-edit.manage-role-assignments": "Manage Role Assignments",
  "project-edit.manage-safety-requirements": "Manage Safety Requirements",
  "project-edit.manage-alerts": "Manage messages",
  "project-edit.manage-day-registrations": "Day registrations",
  "project-edit.delete-button": "Delete Project",
  "project-edit.delete-title": "Delete Project",
  "project-edit.delete-message": "Are you sure you want to delete this project?",
  "project-edit.delete-confirm": "Delete",
  "project-edit.delete-success": "Project deleted successfully.",
  "project-edit.delete-error": "An error occurred while deleting the project.",
  "project-edit.qr-code-button": "QR Code",
  "project-edit.qr-code-modal-title": "Project QR Code",
  "project-edit.qr-code-modal-alt": "Project QR code image",
  "project-edit.load-error": "Error loading the project",
  "project-form.general-data": "General data",
  "project-form.address": "Address",
  "project-form.title": "Title",
  "project-form.logo": "Logo",
  "project-form.click-to-upload-logo": "Click to upload logo",
  "project-form.remove-logo": "Remove logo",
  "project-form.active": "Active",
  "project-form.description": "Description",
  "project-form.project-code": "Project Code",
  "project-form.client": "Customer",
  "project-form.contractor": "Contractor",
  "project-form.owner": "Owner",
  "project-form.chief-safety-officer": "Chief safety officer:",
  "project-form.start-date": "Start Date",
  "project-form.end-date": "End Date",
  "project-form.city": "City",
  "project-form.street": "Street",
  "project-form.house-number": "House Number",
  "project-form.zip-code": "Postal code",
  "project-form.party-organisation": "Organisation",
  "project-form.organisation-none": "None",
  "project-form.admins": "Project Administrators",
  "project-form.safety-contact": "Safety Contact",
  "project-form.safety-contact.select": "Select Safety Contact",
  "project-form.safety-contact.select-contractor-first": "Select a contractor first",
  "project-form.safety-director": "Safety Director",
  "project-form.safety-director.select": "Select Safety Director",
  "project-form.safety-director.select-client-first": "Select a client first",
  "project-form.project-risks": "Project Risks",
  "project-form.collision-hazard": "Collision Hazard",
  "project-form.falling-from-height": "Falling from Height",
  "project-form.electrocution": "Electrocution",
  "project-form.hoisting-and-transport": "Hoisting and Transport",
  "project-form.hazardous-substances": "Hazardous Substances",
  "project-form.save-success": "Project saved successfully.",
  "project-form.save-error": "An error occurred while saving the project.",
  "project-form.save-validation": "Please fix errors in the form.",
  "project-alerts.page-title": "Messages for",
  "project-alerts.create-button": "Create message",
  "project-alerts.create-title": "Create message",
  "project-alerts.edit-title": "Edit message",
  "project-alerts.empty": "There are no messages for this project yet.",
  "project-alerts.valid-from": "Valid from",
  "project-alerts.valid-until": "Valid until",
  "project-alerts.target-audience": "Target audience",
  "project-alerts.table.title": "Title",
  "project-alerts.table.category": "Category",
  "project-alerts.table.type": "Type",
  "project-alerts.table.valid-from": "Valid from",
  "project-alerts.table.valid-until": "Valid until",
  "project-alerts.table.target-audience": "Target audience",
  "project-alerts.table.translations": "Video translations",
  "project-alerts.table.no-translations": "None",
  "project-alerts.form.title": "Title",
  "project-alerts.form.title-placeholder": "Enter message title",
  "project-alerts.form.type": "Type",
  "project-alerts.form.category": "Category",
  "project-alerts.form.language": "Language",
  "project-alerts.form.type-text": "Text message",
  "project-alerts.form.type-video": "Video message",
  "project-alerts.form.description": "Description",
  "project-alerts.form.video": "Video",
  "project-alerts.form.choose-video": "Choose video",
  "project-alerts.form.saved-video": "Saved video",
  "project-alerts.form.video-required": "Please select a video.",
  "project-alerts.form.video-upload-failed": "Video upload failed.",
  "project-alerts.form.translate-video": "Translate uploaded video automatically",
  "project-alerts.form.valid-from": "Valid from",
  "project-alerts.form.valid-until": "Valid until",
  "project-alerts.form.date-order-error": "Valid until must be on or after valid from.",
  "project-alerts.category.General": "General",
  "project-alerts.category.Weather": "Weather",
  "project-alerts.category.Logistic": "Logistic",
  "project-alerts.category.Safety": "Safety",
  "project-alerts.translations": "Translations",
  "project-alerts.create-success": "Message created successfully.",
  "project-alerts.create-error": "An error occurred while creating the message.",
  "project-alerts.update-success": "Message updated successfully.",
  "project-alerts.update-error": "An error occurred while updating the message.",
  "project-alerts.delete-title": "Delete message",
  "project-alerts.delete-message": "Are you sure you want to delete this message?",
  "project-alerts.delete-confirm": "Delete",
  "project-alerts.delete-success": "Message deleted successfully.",
  "project-alerts.delete-error": "An error occurred while deleting the message.",
  "project-day-registrations.page-title": "Day registrations for",
  "project-day-registrations.table.worker": "Worker",
  "project-day-registrations.table.company": "Company",
  "project-day-registrations.table.check-in": "Check-in",
  "project-day-registrations.table.check-out": "Check-out",
  "project-day-registrations.table.still-on-site": "Still on site",
  "project-day-registrations.table.duration": "Duration",
  "project-day-registrations.table.unknown-worker": "Unknown worker",
  "project-day-registrations.table.unknown-company": "Unknown company",
  "project-day-registrations.table.swi-signed": "SWI signed",
  "project-day-registrations.table.swi-signed-yes": "Signed",
  "project-day-registrations.table.swi-signed-no": "Not signed",
  "project-day-registrations.detail.title": "Day registration",
  "project-day-registrations.detail.registration": "Registration",
  "project-day-registrations.detail.swi": "Start work instruction",
  "project-day-registrations.detail.signed-at": "Signed at",
  "project-day-registrations.detail.signature": "Signature",
  "project-day-registrations.detail.not-signed": "No signed start work instruction for this registration.",
  "project-day-registrations.detail.load-error": "Could not load this day registration",
  "certificates.title": "Certificates",
  "certificates.tab-definitions": "Definitions",
  "certificates.tab-for-review": "For Review",
  "certificates.tab-accomplished": "Overview",
  "certificates.new": "New Certificate",
  "certificates.logo": "Logo",
  "certificates.name": "Name",
  "certificates.description": "Description",
  "certificates.issuingOrganisations": "Issuing Organisations",
  "certificates.gracePeriod": "Grace Period",
  "certificates.days": "days",
  "certificates.showOnWorker": "Show on worker",
  "certificates.form.showOnWorker": "Show on worker detail page",
  "certificates.form.showOnWorkerLabel": "Mark holders of this certificate in the app",
  "certificates.newTitle": "New Certificate",
  "certificates.editTitle": "Edit Certificate",
  "certificates.loadError": "Error loading certificate",
  "certificates.loadOrganisationsError": "Error loading organisations",
  "certificates.loadRegistriesError": "Error loading certificate registries",
  "certificates.createSuccess": "Certificate created successfully",
  "certificates.createError": "Error creating certificate",
  "certificates.updateSuccess": "Certificate updated successfully",
  "certificates.updateError": "Error updating certificate",
  "certificates.deleteSuccess": "Certificate deleted successfully",
  "certificates.deleteError": "Error deleting certificate",
  "certificates.logoRequired": "Logo is required for new certificates",
  "certificates.fileError": "Error processing file",
  "certificates.error.registryConflict": "This Registry Source is already assigned to another certificate",
  "certificates.invalidFileType": "Please select a valid image file",
  "certificates.fileTooLarge": "File size must be less than 5MB",
  "certificates.confirmDelete.title": "Delete Certificate",
  "certificates.confirmDelete.message": "Are you sure you want to delete this certificate?",
  "certificates.form.name": "Certificate Name",
  "certificates.form.namePlaceholder": "Enter certificate name",
  "certificates.form.description": "Description",
  "certificates.form.descriptionPlaceholder": "Enter certificate description",
  "certificates.form.logo": "Logo",
  "certificates.form.logoPlaceholder": "Choose certificate logo",
  "certificates.form.logoBackgroundColor": "Logo Background Color",
  "certificates.form.logoBackgroundColorPlaceholder": "Enter background color (e.g., #ffffff)",
  "certificates.form.issuingOrganisation": "Issuing Organisation",
  "certificates.form.issuingOrganisationPlaceholder": "Select issuing organisation",
  "certificates.form.issuingOrganisations": "Issuing Organisations",
  "certificates.form.issuingOrganisationsPlaceholder": "Select issuing organisations",
  "certificates.form.gracePeriod": "Grace Period (Days)",
  "certificates.form.gracePeriodPlaceholder": "Enter grace period in days",
  "certificates.form.registrySource": "Registry Source",
  "certificates.form.registrySourcePlaceholder": "Select registry source (optional)",
  "certificates.form.validityYears": "Validity period (Years, optional)",
  "certificates.form.validityYearsPlaceholder": "Enter validity period",
  "certificates-review.empty-state": "No certificates pending review",
  "certificates-review.person": "Person",
  "certificates-review.certificate": "Certificate",
  "certificates-review.certificate-number": "Certificate number",
  "certificates-review.submitted-on": "Submitted on",
  "certificates-review.date-of-birth": "Date of birth",
  "certificates-review.issued-on": "Issued on",
  "certificates-review.expires-on": "Expires on",
  "certificates-review.document": "Documents",
  "certificates-review.view-document": "View document",
  "certificates-review.view-document-n": "View document {n}",
  "certificates-review.approve": "Approve",
  "certificates-review.reject": "Reject",
  "certificates-review.approved-success": "Certificate approved successfully",
  "certificates-review.rejected-success": "Certificate rejected successfully",
  "certificates-review.error": "Something went wrong. Please try again.",
  "certificates-review.error-load": "Failed to load certificates",
  "certificates-review.not-found": "Certificate not found",
  "certificates-review.person-details": "Person",
  "certificates-review.certificate-details": "Certificate",
  "certificates-review.status-approved": "Approved",
  "certificates-review.status-rejected": "Rejected",
  "certificates-review.rejection-reason": "Reason for rejection",
  "certificates-review.rejection-reason-placeholder": "Optional reason for rejection",
  "certificates-review.confirm-reject": "Confirm rejection",
  "certificates-review.cancel-reject": "Cancel",
  "certificates-review.rejection-modal-title": "Reject certificate",
  "certificates-review.rejection-modal-description": "Optionally provide a reason. It will be included in the rejection notification sent to the user.",
  "certificates-accomplished.select-organisation": "Select an organisation to view accomplished certificates",
  "certificates-accomplished.person": "Person",
  "certificates-accomplished.holder-name": "Holder name",
  "certificates-accomplished.certificate": "Certificate",
  "certificates-accomplished.date-of-birth": "Date of birth",
  "certificates-accomplished.expires-on": "Expires on",
  "certificates-accomplished.source": "Source",
  "certificates-accomplished.source-registry": "Register",
  "certificates-accomplished.source-manual": "Manual",
  "certificates-accomplished.status": "Status",
  "certificates-accomplished.status-valid": "Valid",
  "certificates-accomplished.status-about-to-expire": "About to expire",
  "certificates-accomplished.status-expired": "Expired",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.actions": "Actions",
  "common.create": "Create",
  "common.update": "Update",
  "common.global": "Global",
  "content-owner.label": "Owner",
  "content-owner.global": "Global",
  "content-owner.organisation": "Organisation",
  "content-owner.organisation.required": "Organisation is required",
  "content-owner.project": "Project",
  "content-owner.project.required": "Project is required",
  "project-form.end-date-before-start-date": "The end date cannot be before the start date.",
  "persons.table.avatar": "Avatar",
  "persons.table.first-name": "First Name",
  "persons.table.last-name": "Last Name",
  "persons.table.email": "Email",
  "persons.table.employments": "Employments",
  "persons.table.last-login": "Last login",
  "persons.table.never-logged-in": "Never logged in",
  "persons.table.actions": "Actions",
  "persons.table.invitation-status": "Invitation Status",
  "persons.new": "New Person",
  "persons.title": "List of Persons",
  "persons.already-has-account": "This person already has an account",
  "persons.invitation-sent": "Invitation sent successfully",
  "persons.invitation-status.accepted": "Accepted",
  "persons.invitation-status.expired": "Expired",
  "persons.invitation-status.invited": "Invited",
  "persons.invitation-status.not-invited": "Not invited",
  "person-edit.title-edit": "Edit Person",
  "person-edit.title-new": "New Person",
  "person-edit.binding-anomaly-warning": "This person's employments are linked to more than one app account. This is a data problem — contact support to resolve it before managing employments.",
  "person-edit.delete": "Delete Person",
  "person-edit.close": "Close",
  "person-edit.delete-button": "Delete Person",
  "person-edit.delete-title": "Delete Person",
  "person-edit.delete-message": "Are you sure you want to delete this person?",
  "person-edit.delete-confirm": "Delete",
  "person-edit.delete-success": "Person deleted successfully.",
  "person-edit.delete-error": "An error occurred while deleting the person.",
  "person-edit.already-has-account": "This person already has an account",
  "person-edit.invite-button": "Send invitation",
  "person-edit.reinvite-button": "Resend invitation",
  "person-edit.edit-forbidden": "You do not have access to edit this person.",
  "person-edit.manage-role-assignments": "Manage Role Assignments",
  "person-role-assignments.scope": "Scope",
  "person-role-assignments.scope-name": "Granted in",
  "person-role-assignments.scope-Organisation": "Organisation",
  "person-role-assignments.scope-Project": "Project",
  "person-role-assignments.add-validation": "Please select a scope and a role.",
  "person-role-assignments.add-success": "Role assignment added.",
  "person-role-assignments.add-forbidden": "You are not an administrator of the selected project.",
  "person-role-assignments.add-duplicate": "This person already has this role here.",
  "person-role-assignments.add-rejected-organisation": "This role cannot be granted at organisation scope.",
  "person-role-assignments.no-organisation": "This person has no organisation, so only project roles can be granted.",
  "person-form.avatar": "Avatar",
  "person-form.avatar.remove": "Remove avatar",
  "person-form.general-data": "General data",
  "person-form.first-name": "First Name",
  "person-form.first-name.placeholder": "Enter first name",
  "person-form.last-name": "Last Name",
  "person-form.last-name.placeholder": "Enter last name",
  "person-form.email": "Email",
  "person-form.email.placeholder": "Enter email address",
  "person-form.gender": "Gender",
  "person-form.gender.male": "Male",
  "person-form.gender.female": "Female",
  "person-form.gender.other": "Other",
  "person-form.date-of-birth": "Date of Birth",
  "person-form.date-of-birth.placeholder": "Enter date of birth",
  "person-form.organisation": "Organisation",
  "person-form.role": "Role",
  "person-form.role.placeholder": "Select role",
  "person-form.employments": "Employments",
  "person-form.save-success": "Person saved successfully.",
  "person-form.save-error": "An error occurred while saving the person.",
  "person-form.save-validation": "Please fix errors in the form.",
  "person-form.employment-required": "At least one employment is required.",
  "person-form.select-organisation-first": "Select the person's organisation before adding an employment.",
  "employment.create-title": "Add new employment",
  "employment.edit-title": "Edit employment",
  "employment.organisation": "Organisation",
  "employment.function": "Function",
  "employment.function-placeholder": "Select function",
  "employment.start-date": "Start date",
  "employment.end-date": "End date (optional)",
  "employment.end-date-read-only": "To change this, use Withdraw employment — it records the reason.",
  "employment.start-date-after-end-date": "The start date cannot be after the end date.",
  "employment.managerial": "Managerial",
  "employment.managerial-label": "Managerial role",
  "employment.active": "Active",
  "employment.inactive": "Inactive",
  "employment.statusForAdminReview": "Awaiting admin review",
  "employment.statusForUserReview": "Awaiting user review",
  "employment.invitation.not-invited": "Not yet invited",
  "employment.invitation.invited": "Invited",
  "employment.invitation.expired": "Invitation expired",
  "employment.withdrawn": "Withdrawn",
  "employment.withdrawn-by": "Withdrawn by {{name}} on {{date}}",
  "employment.end-date-removed-by": "End date removed by {{name}} on {{date}}",
  "employment.withdrawn-by-unknown": "an administrator",
  "employment.withdraw.action": "Withdraw employment",
  "employment.withdraw.title": "Withdraw employment",
  "employment.withdraw.message": "The employment keeps its access until the effective end date. The withdrawal is recorded with your name, the date and the reason.",
  "employment.withdraw.effective-end-date": "Effective end date",
  "employment.withdraw.effective-end-date-hint": "Access ends at the start of this date.",
  "employment.withdraw.last-day-with-access": "Last day with access: {{date}}",
  "employment.withdraw.remove-end-date": "No end date (the employment stays open-ended)",
  "employment.withdraw.no-end-date-hint": "The employment keeps access until an end date is set again.",
  "employment.withdraw.reason": "Reason",
  "employment.approved-with-changes": "Approved with changes to the worker's request",
  "employment.approval-remark": "Remark",
  "employment.withdraw.confirm": "Withdraw",
  "employment.withdraw.confirm-remove": "Remove end date",
  "employment.withdraw.end-date-removed": "End date removed.",
  "employment.withdraw.success": "Employment withdrawn.",
  "employment.withdraw.ends-on": "Access ends on {{date}}",
  "employment.revoke-action": "Revoke offer",
  "employment.revoke-confirm-title": "Revoke employment offer",
  "employment.revoke-confirm-message": "The offer is removed and the invitation link stops working. Nothing was granted yet, so nothing is kept. Continue?",
  "employment.revoke-success": "Employment offer revoked.",
  "employment.create-success": "Employment created successfully.",
  "employment.create-error": "An error occurred while creating the employment.",
  "employment.update-success": "Employment updated successfully.",
  "employment.update-error": "An error occurred while updating the employment.",
  "employment.delete-success": "Employment deleted successfully.",
  "employment.delete-error": "An error occurred while deleting the employment.",
  "employment.delete-confirm-title": "Delete Employment",
  "employment.delete-confirm-message": "Are you sure you want to delete this employment? This action cannot be undone.",
  "employment.timeline.no-employments": "No employment history available.",
  "employment.timeline.add-employment": "Add employment",
  "employment.timeline.present": "Present",
  "context-menu.generic-view.view": "View",
  "context-menu.generic-update-delete.edit": "Edit",
  "context-menu.generic-update-delete.delete": "Delete",

  "role-assignments.title": "Role Assignments for",
  "role-assignments.search-placeholder": "Search persons or organisations...",
  "role-assignments.role-placeholder": "Select a role...",
  "role-assignments.add-assignment": "Add Assignment",
  "role-assignments.avatar-alt": "Avatar or logo",
  "role-assignments.send-invite-to": "Send invite to:",
  "role-assignments.edit-title": "Edit Role Assignment",
  "role-assignments.principal-label": "Principal",
  "role-assignments.role-label": "Role",
  "role-assignments.save": "Save",
  "role-assignments.saving": "Saving...",
  "role-assignments.role-required": "Role is required.",
  "role-assignments.update-success": "Role updated successfully",
  "role-assignments.update-error": "Failed to update role",
  "role-assignments.add-error": "Failed to add role assignment.",
  "role-assignments.delete-error": "Failed to delete role assignment.",
  "role-assignments.add-validation": "Please select a person/organisation and a role.",
  "role-assignments.name": "Name",
  "role-assignments.email": "Email",
  "role-assignments.type": "Type",
  "role-assignments.role": "Role",
  "role-assignments.delete-title": "Delete Role Assignment",
  "role-assignments.delete-message": "Are you sure you want to delete this role assignment?",
  "safety-reports.title-all": "All safety reports",
  "safety-reports.category.Accident": "Accident",
  "safety-reports.category.UnsafeSituation": "Unsafe situation",
  "safety-reports.category.SafeSituation": "Safe situation",
  "safety-reports.status.New": "New",
  "safety-reports.status.InProgress": "In progress",
  "safety-reports.status.Solved": "Solved",
  "safety-reports.status.OnHold": "On hold",
  "safety-reports.table.status": "Status",
  "safety-reports.table.reporter": "Reporter",
  "safety-reports.table.project": "Project",
  "safety-reports.table.assigned-to": "Assigned to",
  "safety-reports.table.description": "Description",
  "safety-reports.table.category": "Category",
  "safety-reports.table.date-created": "Date created",
  "safety-reports.unassigned": "Unassigned",
  "safety-report-detail.error.title": "Failed to load safety report",
  "safety-report-detail.title": "Safety report #{{id}}",
  "safety-report-detail.urgent": "Urgent",
  "safety-report-detail.normal": "Normal",
  "safety-report-detail.anonymous": "Anonymous",
  "safety-report-detail.sections.details": "Details",
  "safety-report-detail.sections.status": "Status",
  "safety-report-detail.sections.logs": "Logs",
  "safety-report-detail.sections.comments": "Comments",
  "safety-report-detail.comments.unknown-author": "Unknown author",
  "safety-report-detail.fields.project": "Project",
  "safety-report-detail.fields.reporter": "Reporter",
  "safety-report-detail.fields.category": "Category",
  "safety-report-detail.fields.urgency": "Urgency",
  "safety-report-detail.fields.created-at": "Created at",
  "safety-report-detail.fields.solved-at": "Solved at",
  "safety-report-detail.fields.description": "Description",
  "safety-report-detail.fields.risk": "Risk",
  "safety-report-detail.fields.photos": "Photos",
  "safety-report-detail.fields.current-status": "Current status",
  "safety-report-detail.fields.assigned-to": "Assigned to",
  "safety-report-detail.unassigned": "Unassigned",
  "safety-report-detail.status-editing-note": "Status and assignment can only be changed by users with the right permissions.",
  "safety-report-detail.no-logs": "No logs available.",
  "safety-report-detail.log.created": "Report created by {{actorName}}",
  "safety-report-detail.log.status-changed": "Status changed by {{actorName}} to {{newStatus}}",
  "safety-report-detail.log.commented": "Comment added by {{actorName}}",
  "safety-report-detail.log.assigned": "Assigned to {{assignedToPersonName}} by {{actorName}}",
  "safety-report-detail.log.unassigned": "Unassigned from person by {{actorName}}",
  "safety-report-detail.log.unknown": "Unknown log entry",
  "safety-report-detail.save-success": "Safety report updated successfully.",
  "safety-report-detail.save-error": "Failed to update safety report.",
  "safety-report-detail.validation-error": "Please fix errors in the form.",

  "safety-reports.create-new": "New Safety Report",
  "safety-report-create.title": "Create Safety Report",
  "safety-report-form.general-information": "General Information",
  "safety-report-form.details": "Details",
  "safety-report-form.category": "Category",
  "safety-report-form.project": "Project",
  "safety-report-form.risk-category": "Risk Category",
  "safety-report-form.risk": "Risk",
  "safety-report-form.description": "Description",
  "safety-report-form.photos": "Photos",
  "safety-report-form.click-to-upload-photos": "Click to upload photos",
  "safety-report-form.selected-photos": "Selected Photos",
  "safety-report-form.urgent": "Urgent",
  "safety-report-form.solved": "Solved",
  "safety-report-form.create-success": "Safety report created successfully.",
  "safety-report-form.create-error": "An error occurred while creating the safety report.",
  "safety-report-form.validation-error": "Please fix errors in the form.",
  "safety-report-form.description-or-photos-required": "Either description or photos is required.",
  "safety-report-form.invalid-file-type": "Invalid file type. Please select an image file.",
  "safety-report-form.file-too-large": "File size too large. Maximum size is 5MB.",

  "safety-report.fields.actions-taken": "Actions Taken",
  "safety-report.fields.victims": "Victims",
  "safety-report.fields.absenteeism": "Absenteeism",
  "safety-report.fields.hospitalised": "Hospitalised",

  "safety-report-detail.add-comment": "Add comment",
  "safety-instructions.title": "Safety Instructions",
  "safety-instructions.create": "New Safety Instruction",
  "safety-instructions.table.title": "Title",
  "safety-instructions.table.type": "Type",
  "safety-instructions.table.organisation": "Organisation",
  "safety-instructions.table.project": "Project",
  "safety-instructions.table.status": "Status",
  "safety-instructions.edit.title": "Edit Safety Instruction",
  "safety-instructions.new.title": "New Safety Instruction",
  "safety-instructions.delete-button": "Delete Safety Instruction",
  "safety-instructions.delete-title": "Delete Safety Instruction",
  "safety-instructions.delete-message": "Are you sure you want to delete this safety instruction?",
  "safety-instructions.delete-confirm": "Delete",
  "safety-instructions.toast.load-error": "Failed to load safety instruction.",
  "safety-instructions.toast.delete-success": "Safety instruction deleted successfully.",
  "safety-instructions.toast.delete-error": "Failed to delete safety instruction.",

  "safety-instructions.create-modal.header": "Create safety instruction",
  "safety-instructions.create-modal.title": "Title",
  "safety-instructions.create-modal.type": "Type",
  "safety-instructions.create-modal.type.generic": "Generic",
  "safety-instructions.create-modal.type.video": "Video",
  "safety-instructions.create-modal.type.required": "Type is required",
  "safety-instructions.create-modal.cancel": "Cancel",
  "safety-instructions.create-modal.create": "Create",

  "safety-instruction-form.details": "Details",
  "safety-instruction-form.name": "Name",
  "safety-instruction-form.name.required": "Name is required",
  "safety-instruction-form.name.maxlength": "Name cannot exceed 200 characters",
  "safety-instruction-form.type": "Type",
  "safety-instruction-form.type.Generic": "Generic",
  "safety-instruction-form.type.Video": "Video",
  "safety-instruction-form.created-by": "Created by",
  "safety-instruction-form.owner": "Owner",
  "safety-instruction-form.click-to-upload-thumbnail": "Click to upload logo",
  "safety-instruction-form.thumbnail": "Logo",
  "safety-instruction-form.remove-thumbnail": "Remove logo",
  "safety-instruction-form.using-organisation-logo": "Using organisation logo",
  "safety-instruction-form.status": "Status",
  "safety-instruction-form.status-draft": "Draft",
  "safety-instruction-form.status-published": "Published",
  "safety-instruction-form.usable-in-swi": "Start work instruction",
  "safety-instruction-form.usable-in-swi-label": "Can be used in SWI / daily registration",
  "safety-instruction-form.video": "Video",
  "safety-instruction-form.save-validation": "Please fix errors in the form.",
  "safety-instruction-form.save-error": "An error occurred while saving the safety instruction.",
  "safety-instruction-form.save-success": "Safety instruction saved successfully.",
  "safety-instruction-form.save-name-not-translated": "Name is not translated to all selected languages",
  "safety-instruction-form.blocks": "Blocks",
  "content-blocks.text": "Text",
  "content-blocks.text-placeholder": "Enter text here",
  "content-blocks.image": "Image",
  "content-blocks.image.drop-image": "Drop image here",
  "content-blocks.image.or-click-to-select": "or click to select",
  "content-blocks.document": "Document",
  "content-blocks.document.drop-document": "Drop PDF here",
  "content-blocks.document.or-click-to-select": "or click to select",
  "content-blocks.document.download": "Download document",
  "content-blocks.video": "Video",
  "content-blocks.video.video-url": "Video URL",
  "content-blocks.video.preview": "Video preview",
  "content-blocks.video.unsupported": "Only https://youtube.com and https://vimeo.com videos are supported",
  "content-blocks.multiple-choice-question": "Multiple Choice Question",
  "content-blocks.mcq.question": "Question",
  "content-blocks.mcq.question-placeholder": "Enter your question here",
  "content-blocks.mcq.answers": "Answers",
  "content-blocks.mcq.answer-placeholder": "Enter answer",
  "content-blocks.mcq.correct": "Correct",
  "content-blocks.mcq.add-answer": "Add Answer",
  "content-blocks.mcq.all-correct-answers-required": "All correct answers must be selected",
  "content-blocks.mcq.question-required": "Question is required",
  "content-blocks.mcq.answer-required": "Answer is required",
  "content-blocks.mcq.correct-answers-required": "At least one correct answer is required",
  "content-blocks.page-separator": "Page Separator",
  "content-blocks.page-separator-placeholder": "Enter page title",

  "checklists.title": "Checklists",
  "checklists.create": "New Checklist",
  "checklists.status": "Status",
  "checklists.organisation": "Organisation",
  "checklists.project": "Project",
  "checklists.created-by": "Created by",
  "checklists.created-at": "Created at",
  "checklists.status.concept": "Concept",
  "checklists.status.published": "Published",

  "checklists.create-modal.header": "Create checklist",
  "checklists.create-modal.title": "Title",
  "checklists.create-modal.title.required": "Title is required",
  "checklists.create-modal.create": "Create",
  "checklists.create-modal.error.create-failed": "Failed to create checklist",

  "create-checklist-modal.error.create-failed": "Failed to create checklist",

  "checklists.edit.placeholder": "Checklist content editor will be implemented here. You can edit the title, description, and checklist items.",
  "checklists.edit.notFound": "Checklist not found",

  "checklists.delete-title": "Delete checklist",
  "checklists.delete-message": "Are you sure you want to delete this checklist? This action cannot be undone.",
  "checklists.delete-confirm": "Delete",
  "checklists.delete-success": "Checklist deleted successfully",
  "checklists.delete-error": "Failed to delete checklist",

  "checklists.publish": "Publish",
  "checklists.publish-title": "Publish checklist",
  "checklists.publish-message": "Are you sure you want to publish this checklist? Once published, the checklist items cannot be edited and status cannot be changed back.",
  "checklists.publish-confirm": "Publish",
  "checklists.publish-success": "Checklist published successfully",
  "checklists.publish-error": "Failed to publish checklist",
  "checklists.publish-error-new-checklist": "This is a new checklist. Please save it first before publishing.",
  "checklists.publish-error-unsaved-changes": "Please save your changes before publishing.",
  "checklists.publish-error-not-concept": "Only checklists in Concept status can be published.",

  "checklists.item.delete-title": "Delete item",
  "checklists.item.delete-message": "Are you sure you want to delete this checklist item?",
  "checklists.item.delete-confirm": "Delete",

  "checklists.save-success": "Checklist saved successfully",
  "checklists.save-error": "Failed to save checklist",

  "checklists.error.id-not-found": "Checklist ID not found",
  "checklists.error.load-failed": "Failed to load checklist",

  "checklist-form.title": "Title",
  "checklist-form.title.required": "Title is required",
  "checklist-form.title.maxlength": "Title cannot exceed 200 characters",
  "checklist-form.status": "Status",
  "checklist-form.description": "Description",
  "checklist-form.usable-in-swi": "Start work instruction",
  "checklist-form.usable-in-swi-label": "Can be used in SWI / daily registration",
  "checklist-form.items": "Checklist Items",
  "checklist-form.item.placeholder": "Enter checklist item...",
  "checklist-form.item.required": "Item text is required",
  "checklist-form.item.maxlength": "Item text cannot exceed 500 characters",
  "checklist-form.item.move-up": "Move item up",
  "checklist-form.item.move-down": "Move item down",
  "checklist-form.item.remove": "Remove item",
  "checklist-form.add-item": "Add item",
  "checklist-form.save-validation": "Please fix the form errors before saving",
  "checklist-form.save-title-not-translated": "Title is not translated to all selected languages",
  "checklist-form.save-items-not-translated": "Not all items are translated to all selected languages",

  "thesaurus.title": "Manage platform thesaurus",
  "thesaurus.add-node": "+ Add node",
  "thesaurus.error": "Failed to load thesaurus data",
  "thesaurus.edit-function": "Edit Function",
  "thesaurus.add-function": "Add Function",
  "thesaurus.function-name": "Function Name",
  "thesaurus.function-name-placeholder": "Enter function name",
  "thesaurus.function-description": "Description",
  "thesaurus.function-description-placeholder": "Enter function description",
  "thesaurus.synonyms": "Synonyms",
  "thesaurus.synonyms-placeholder": "Add synonyms",
  "thesaurus.non-selectable": "Non-selectable",
  "thesaurus.non-selectable-label": "This node cannot be selected as a function",
  "thesaurus.management-organisation": "Management Organisation",
  "thesaurus.load-organisations-error": "Error loading organisations",
  "thesaurus.save-edit-success": "Updated function",
  "thesaurus.save-new-success": "Created function",
  "thesaurus.save-error": "Failed to save function",
  "thesaurus.save-name-not-translated": "Name is not translated to all selected languages",
  "thesaurus.save-description-not-translated": "Description is not translated to all selected languages",
  "thesaurus.delete-title": "Delete Function",
  "thesaurus.delete-message": "Are you sure you want to delete this function? This action cannot be undone.",
  "thesaurus.delete-confirm": "Delete",
  "thesaurus.delete-success": "Function deleted successfully",
  "thesaurus.delete-error": "Failed to delete function",
  "thesaurus.cannot-delete-parent-function": "Cannot delete a function that has children. Please delete or move the children first.",

  "safety-requirements.title": "Safety Requirements",
  "safety-requirements.create": "New Safety Requirement",
  "safety-requirements.create-success": "Safety requirement created successfully",
  "safety-requirements.create-error": "Failed to create safety requirement",
  "safety-requirements.update-success": "Safety requirement updated successfully",
  "safety-requirements.update-error": "Failed to update safety requirement",
  "safety-requirements.delete-success": "Safety requirement deleted successfully",
  "safety-requirements.delete-error": "Failed to delete safety requirement",
  "safety-requirements.enable-requirement": "Enable requirement",
  "safety-requirements.disable-requirement": "Disable requirement",
  "safety-requirements.enable-success": "Organisation requirement enabled successfully",
  "safety-requirements.enable-error": "Failed to enable organisation requirement",
  "safety-requirements.disable-success": "Organisation requirement disabled successfully",
  "safety-requirements.disable-error": "Failed to disable organisation requirement",
  "safety-requirements.type.Certificates": "Certificates",
  "safety-requirements.type.Checklists": "Checklists",
  "safety-requirements.type.SafetyInstructions": "Safety Instructions",
  "safety-requirements.type.Toolboxes": "Toolboxes",
  "safety-requirements.edit.title": "Edit safety requirement",
  "safety-requirements.form.title": "Title",
  "safety-requirements.form.title.placeholder": "Title of the safety requirement",
  "safety-requirements.form.type": "Type of safety requirement",
  "target-audience.form.include": "Target audience",
  "target-audience.form.exclude": "Exclude",
  "target-audience.include-organisation": "Include everyone from organisation",
  "target-audience.exclude-organisation": "Exclude everyone from organisation",
  "target-audience.include-function": "Include everyone with function",
  "target-audience.exclude-function": "Exclude everyone with function",
  "target-audience.include-function-group": "Include everyone in function group",
  "target-audience.exclude-function-group": "Exclude everyone in function group",
  "target-audience.include-management": "Include management only",
  "target-audience.exclude-management": "Exclude management",
  "target-audience.include-everyone": "Include everyone",
  "target-audience.exclude-everyone": "Exclude everyone",
  "target-audience.everyone": "Everyone",
  "target-audience.management": "Management",
  "target-audience.organisation.placeholder": "Organisation",
  "target-audience.function.placeholder": "Function or group",
  "safety-requirements.add": "Add safety requirement",
  "safety-requirements.page-title": "Safety requirements for",
  "safety-requirements.include": "Include:",
  "safety-requirements.exclude": "Exclude:",
  "safety-requirements.none": "None",

  "organisation-safety-requirement.delete-title": "Delete Safety Requirement",
  "organisation-safety-requirement.delete-message": "Are you sure you want to delete this safety requirement? This action cannot be undone.",
  "organisation-safety-requirement.delete-confirm": "Delete",

  "project-safety-requirement.delete-title": "Delete Safety Requirement",
  "project-safety-requirement.delete-message": "Are you sure you want to delete this safety requirement? This action cannot be undone.",
  "project-safety-requirement.delete-confirm": "Delete",

  "safety-requirements.show-inherited-options": "Show options inherited from",
  "safety-requirements.inherited-from-organisation": "Inherited from organisation",
  "safety-requirements.organisation-logo": "Organisation logo",

  "field.visible-in-app": "Field is visible in the app",
  "field.translation-original": "Original",
  "field.fill-with-ai": "Fill with AI",
  "field.fill-with-ai.error": "Could not fill in the translations, please try again",
  "field.ai-filled": "AI generated",
  "field.ai-filled.stale": "Original changed - refill with AI",

  "function-selector.title": "Select Function",
  "function-selector.search.placeholder": "Search functions...",
  "function-selector.search.clear": "Clear",
  "function-selector.search.no-results": "No results found",
  "function-selector.root": "All functions",
  "function-selector.select-this-category": "Select this category",
  "function-selector.cancel": "Cancel",

  "organisation-edit.employees": "Employees",
  "organisation-employees.page-title": "Employees of {{organisation}}",
  "organisation-employees.name": "Name",
  "organisation-employees.email": "Email",
  "organisation-employees.start-date": "Employed since",
  "organisation-employees.function": "Function",
  "organisation-employees.invitation-status": "Invitation status",

  "i18n.language-selector.select": "Select Languages",
  "i18n.language-selector.full.nl": "Dutch (NL)",
  "i18n.language-selector.full.bg": "Bulgarian (BG)",
  "i18n.language-selector.full.de": "German (DE)",
  "i18n.language-selector.full.en": "English (EN)",
  "i18n.language-selector.full.pl": "Polish (PL)",
  "i18n.language-selector.full.pt": "Portuguese (PT)",
  "i18n.language-selector.full.ro": "Romanian (RO)",
  "i18n.language-selector.full.tr": "Turkish (TR)",
  "i18n.language-selector.short.nl": "NL",
  "i18n.language-selector.short.bg": "BG",
  "i18n.language-selector.short.de": "DE",
  "i18n.language-selector.short.en": "EN",
  "i18n.language-selector.short.pl": "PL",
  "i18n.language-selector.short.pt": "PT",
  "i18n.language-selector.short.ro": "RO",
  "i18n.language-selector.short.tr": "TR",

  "toolboxes.title": "List of toolboxes",
  "toolboxes.select-organisation-first": "Please select an organisation first",
  "toolboxes.select-scope-first": "Please select a scope first",
  "toolboxes.project-toolboxes": "Project Toolboxes",
  "toolboxes.inherited-toolboxes": "From the Organisation",
  "toolboxes.no-project-toolboxes": "No Toolboxes found for this Project.",
  "toolboxes.error-load-project-toolboxes": "Failed to load the Toolboxes for this Project",
  "toolboxes.create": "New toolbox",
  "toolboxes.no-organisation-toolboxes": "No Toolboxes found for this Organisation.",
  "toolboxes.no-platform-toolboxes": "There are no Platform Toolboxes.",
  "toolboxes.new.title": "New Toolbox",
  "toolboxes.edit.title": "Edit Toolbox",
  "toolboxes.platform": "Platform",
  "toolboxes.platform-option": "PLATFORM",
  "toolboxes.available-toolboxes": "Available Toolboxes",
  "toolboxes.enabled-toolboxes": "Enabled Toolboxes",
  "toolboxes.platform-toolboxes": "Platform toolboxes",
  "toolboxes.filter-administrative-organisation": "Administrative organisation",
  "toolboxes.filter-not-set": "Not set",
  "toolboxes.no-platform-toolboxes-for-filter": "No platform toolboxes match the selected administrative organisation.",
  "toolboxes.platform-toolbox-label": "This is a platform toolbox that was enabled for this organisation",
  "toolboxes.assign-to-organisation": "Assign to organisation",
  "toolboxes.remove-from-organisation": "Remove from organisation",
  "toolboxes.enable-for-users": "Enable toolbox for users",
  "toolboxes.disable-for-users": "Disable toolbox for users",
  "toolboxes.error-load-platform-toolboxes": "Failed to load platform toolboxes.",
  "toolboxes.error-load-organisation-toolboxes": "Failed to load organisation toolboxes.",
  "toolboxes.error-load-platform-toolboxes-for-organisation": "Failed to load platform toolboxes for organisation.",
  "toolboxes.error-assign-to-organisation": "Failed to assign toolbox to organisation.",
  "toolboxes.error-remove-from-organisation": "Failed to remove toolbox from organisation.",
  "toolboxes.error-enable-toolbox-for-users": "Failed to enable toolbox for users.",
  "toolboxes.error-disable-toolbox-for-users": "Failed to disable toolbox for users.",
  "toolboxes.type-synchronous": "Synchronous",
  "toolboxes.type-asynchronous": "Asynchronous",

  "toolbox-edit.delete-button": "Delete Toolbox",
  "toolbox-edit.delete-title": "Delete Toolbox",
  "toolbox-edit.delete-message": "Are you sure you want to delete this toolbox?",
  "toolbox-edit.delete-confirm": "Delete",
  "toolbox-edit.toast.load-error": "Failed to load toolbox.",
  "toolbox-edit.toast.delete-success": "Toolbox deleted successfully.",
  "toolbox-edit.toast.delete-error": "Failed to delete toolbox.",
  "toolbox-edit.toast.delete-conflict": "Cannot delete a platform toolbox that is enabled for an organisation.",

  "toolbox-form.details": "Details",
  "toolbox-form.name": "Name",
  "toolbox-form.name.required": "Name is required",
  "toolbox-form.name.maxlength": "Name is too long (max 200 characters)",
  "toolbox-form.created-by": "Created by",
  "toolbox-form.organisation": "Organisation",
  "toolbox-form.project": "Project",
  "toolbox-form.administrative-organisation": "Administrative organisation",
  "toolbox-form.version": "Version",
  "toolbox-form.status": "Status",
  "toolbox-form.type": "Toolbox type",
  "toolbox-form.type-synchronous": "Synchronous (on site)",
  "toolbox-form.type-asynchronous": "Asynchronous (individually)",
  "toolbox-form.status-concept": "Concept",
  "toolbox-form.status-published": "Published",
  "toolbox-form.status-archived": "Archived",
  "toolbox-form.thumbnail": "Logo",
  "toolbox-form.click-to-upload-thumbnail": "Click to upload logo",
  "toolbox-form.remove-thumbnail": "Remove",
  "toolbox-form.using-organisation-logo": "Using organisation logo",
  "toolbox-form.categories": "Categories",
  "toolbox-form.categories-placeholder": "Select categories",
  "toolbox-form.categories-selected": "{{count}} categories selected",
  "toolbox-form.promote": "Promotion",
  "toolbox-form.promote-label": "Show on top",
  "toolbox-form.usable-in-swi": "Start work instruction",
  "toolbox-form.usable-in-swi-label": "Can be used in SWI / daily registration",
  "toolbox-form.description": "Description",
  "toolbox-form.blocks": "Content blocks",
  "toolbox-form.save-error": "Failed to save toolbox",
  "toolbox-form.save-success": "Toolbox saved successfully",
  "toolbox-form.save-name-not-translated": "Name is not translated to all selected languages",
  "toolbox-form.save-description-not-translated": "Description is not translated to all selected languages",
  "toolbox-form.save-validation": "Please fix errors in the form",

  "toolbox-analysis.button": "Analysis",
  "toolbox-analysis.tab-title": "Analysis:",
  "toolbox-analysis.title": "Toolbox analysis:",
  "toolbox-analysis.details-title": "Details",
  "toolbox-analysis.details.toolbox-name": "Toolbox",
  "toolbox-analysis.details.toolbox-type": "Toolbox type",
  "toolbox-analysis.details.organisation-name": "Organisation",
  "toolbox-analysis.categories": "Categories",
  "toolbox-analysis.organisation-title": "Organisation",
  "toolbox-analysis.meetings-title": "Meetings",
  "toolbox-analysis.table.started": "Started",
  "toolbox-analysis.table.ended": "Ended",
  "toolbox-analysis.table.host": "Host",
  "toolbox-analysis.table.participants": "Participants",
  "toolbox-analysis.toast.load-error": "Failed to load meetings.",
  "toolbox-analysis.toast.load-employees-error": "Failed to load organisation employees.",
  "toolbox-analysis.organisation.name": "Name",
  "toolbox-analysis.organisation.last-followed": "Last followed",
  "toolbox-analysis.organisation.not-followed": "Not followed",
  "toolbox-analysis.organisation.no-employees": "No employees found.",
  "toolbox-analysis.export": "Export",
  "toolbox-analysis.csv.first-name": "First name",
  "toolbox-analysis.csv.last-name": "Last name",
  "toolbox-analysis.csv.followed": "Followed",
  "toolbox-analysis.csv.followed-yes": "Yes",
  "toolbox-analysis.csv.followed-no": "No",
  "toolbox-analysis.csv.last-followed": "Last followed",

  "toolbox-organisations-analysis.table.toolboxes-followed": "Toolboxes followed",
  "toolbox-organisations-analysis.empty": "No employees found.",
  "toolbox-organisations-analysis.toast.load-error": "Failed to load toolbox analysis.",
  "toolbox-organisations-analysis.toast.load-categories-error": "Failed to load toolbox categories.",
  "toolbox-organisations-analysis.filters.from": "From",
  "toolbox-organisations-analysis.filters.to": "To",
  "toolbox-organisations-analysis.filters.types": "Types",
  "toolbox-organisations-analysis.filters.types.placeholder": "Select types...",
  "toolbox-organisations-analysis.filters.types.synchronous": "Synchronous",
  "toolbox-organisations-analysis.filters.types.asynchronous": "Asynchronous",
  "toolbox-organisations-analysis.filters.types.manual": "Manual",
  "toolbox-organisations-analysis.filters.categories": "Categories",
  "toolbox-organisations-analysis.filters.categories.placeholder": "Select categories...",
  "toolbox-organisations-analysis.filters.categories-selected": "{{count}} categories selected",

  "toolbox-meeting.title": "Toolbox meeting:",
  "toolbox-meeting.details-title": "Details",
  "toolbox-meeting.details.toolbox-name": "Toolbox",
  "toolbox-meeting.details.toolbox-type": "Toolbox type",
  "toolbox-meeting.details.organisation-name": "Organisation",
  "toolbox-meeting.start-date": "Start date",
  "toolbox-meeting.end-date": "End date",
  "toolbox-meeting.host": "Host",
  "toolbox-meeting.description": "Description",
  "toolbox-meeting.participants-count": "Participants",
  "toolbox-meeting.participants-title": "Participants",
  "toolbox-meeting.toast.load-error": "Failed to load meeting details.",

  "validation.optional-suffix": " (optional)",
  "validation.required": "This value is required",
  "validation.minlength": "The value is too short, must be at least {{required}} characters (type {{missing}} more)",
  "validation.maxlength": "The value is too long, must be at most {{required}} characters ({{tooMany}} too many)",
  "validation.email": "Invalid email address",
  "validation.min": "The value is too small, must be {{required}} or bigger",
  "validation.max": "The value is too large, must be {{required}} or smaller",
  "validation.dateValidator": "Invalid date, must be between year {{minYear}} and {{maxYear}}",
  "validation.onlyLettersAndDigits": "Only letters and digits are allowed",
  "validation.anythingExceptOnlyWhitespaces": "Must contain any character like a letter or a digit",
  "validation.unknown": "Unknown error occurred",

  "review-people.tab-title": "Review employments",
  "review-people.header": "Employment requests",
  "review-people.description": "Review employment requests from the Persons section.",
  "review-people.organisations.all": "All organisations",
  "review-people.empty.no-organisations": "There are no employment requests to review for your organisations.",
  "review-people.approve.title": "Approve employment request",
  "review-people.approve.action": "Approve",
  "review-people.approve.confirm": "Approve",
  "review-people.approve.remark": "Remark for the worker",
  "review-people.approve.remark-placeholder": "Why did you change the request?",
  "review-people.approve.remark-hint": "Required because you changed the request. The worker sees the changes and this remark in the app.",
  "review-people.reject.title": "Reject employment request",
  "review-people.reject.message": "Are you sure you want to reject this employment request?",
  "review-people.reject.reason": "Reason for rejection",
  "review-people.reject.action": "Reject",
  "review-people.reject.confirm": "Reject",
  "review-people.toast.approved": "Employment request approved.",
  "review-people.toast.rejected": "Employment request rejected.",
  "review-people.toast.forbidden": "You don't have permissions to manage employments for {{organisationName}}.",
  "review-people.table.requested-on": "Requested on",
  "review-people.table.person": "Person",
  "review-people.table.email": "Email",
  "review-people.table.organisation": "Organisation",
  "review-people.table.function": "Function",
  "review-people.table.start-date": "Start date",
  "review-people.table.end-date": "End date",

  "email-log.title": "Email log",
  "email-log.table.sent-at": "Sent at",
  "email-log.table.recipient": "Recipient",
  "email-log.table.type": "Type",
  "email-log.table.subject": "Subject",
  "email-log.table.status": "Status",
  "email-log.type-PasswordReset": "Password reset",
  "email-log.type-Invitation": "Invitation",
  "email-log.type-EmploymentReviewApproved": "Employment approved",
  "email-log.type-EmploymentReviewRejected": "Employment rejected",
  "email-log.status-Sent": "Sent",
  "email-log.status-DeliveryError": "Delivery error",
  "email-log.status-FatalError": "Fatal error",

  "": ""
}
